import React, { Component, Fragment } from 'react'
import { Link } from 'react-static'
import styled from 'styled-components'

import Quote from './Quote'
import Clip from './Clip'

const white = `rgba(241, 250, 238, 1)`
const darkblue = `rgba(23, 104, 172, 1)`
const green = `rgba(168, 218, 220, 1)`
const pink = `#FF6B98`

const MastHead = styled.header`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
`
const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  max-width: 800px;
  margin: 0 auto;
  padding: 0 15px;
`
const QuoteContainer = Container.extend`
  padding-left: 30px;
  padding-right: 30px;
  @media (min-width: 500px) {
    padding-left: 50px;
    padding-right: 0;
  }
`
const Avatar = styled.img`
  height: auto;
  border-radius: 50%;
  margin: 20px 15px;
  max-width: calc(100% - 30px);
  @media (min-width: 768px) {
    max-width: 50%;
    flex: 6;
    height: auto;
    margin: 0;
  }
  @media (min-width: 1200px) {
    flex: 6;
  }
`
const Bio = styled.div`
  @media (min-width: 768px) {
    flex: 6;
  }
  @media (min-width: 1200px) {
    flex: 6;
  }
`
const BioContainer = styled.div`
  background: ${green};
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  max-width: 880px;
  margin: 30px 15px 150px 15px;
  @media (min-width: 768px) {
    padding: 40px;
    margin: 120px 15px 240px 15px;
  }
  border: 2px solid ${darkblue};
`
const Name = styled.h1`
  background: ${white};
  font-size: 28px;
  margin: 0 15px;
  @media (min-width: 768px) {
    margin-left: -100px;
    font-size: 40px;
  }
  @media (min-width: 992px) {
    font-size: 60px;
  }
  margin-bottom: 20px;
  padding: 10px 20px;
  text-transform: uppercase;
  font-weight: 100;
`
const Title = styled.p`
  font-family: 'Raleway';
  margin: 0 15px;
  margin-bottom: 20px;
  padding: 13px 20px 10px 20px;
  background: ${pink};
  font-size: 18px;
  @media (min-width: 768px) {
    margin-left: -75px;
    font-size: 28px;
  }
  text-transform: uppercase;
`
const Copy = styled.p`
  font-family: 'Raleway';
  margin: 0 15px;
  line-height: 1.5;
  background: ${darkblue};
  color: ${white};
  @media (min-width: 768px) {
    margin-left: -50px;
  }
  margin-bottom: 15px;
  padding: 15px 20px;
`

class Home extends Component {
  render() {
    return (
      <Fragment>
        <MastHead>
          <BioContainer>
            <Avatar
              alt=""
              src={`https://res.cloudinary.com/mattcdowning/image/upload/f_auto/Image_uir1b3.png`}
            />
            <Bio>
              <Name>Matt Downing</Name>
              <Title>Web Developer & Strategist</Title>
              <Copy>Helping businesses thrive online.</Copy>
            </Bio>
          </BioContainer>
        </MastHead>
        <QuoteContainer>
          <Quote
            text={`Matt's kind, efficient, and a total pleasure to work with!`}
            name="Jocelyn K. Glei"
            link="https://reset-course.com"
          />
          <Quote
            text={`It is refreshing to get this type of quality web development.`}
            name="Neil Schuster"
            link="https://nolayingup.com"
          />
          <Quote
            text={`Matt provided spot on insight and delivered a website I could not be
            happier with.`}
            name="Bennett Zamoff"
            link="https://tampabayintl.netlify.app/"
          />
          <Quote
            text={`I have recieved high praise for our website’s look and feel, ease of
        use, and color selection!`}
            name="Lynn Villyard"
            link="https://odyssey-center.netlify.app/"
          />
          <Quote
            text={`
        If you want your website designed and developed, I couldn't recommend anyone more highly.`}
            name="Benjamin Hardy"
            link="https://www.benjaminhardy.com"
          />
        </QuoteContainer>
        <Clip />
      </Fragment>
    )
  }
}
export default Home



// WEBPACK FOOTER //
// /opt/build/repo/src/containers/Home.js